import * as React from "react"
import styled from "styled-components"
import { icons } from "src/assets"

const Icons = styled.div`
  display: flex;
`
const SocialIcons = styled.div`
  height: 29px;
  width: 29px;
  margin-right: 10px;
  margin-top: 2px;
`
const ImageSection = styled.img`
  height: 100%;
  width: 100%;
`

const ShareIcons = () => {
  return (
    <Icons>
      <SocialIcons>
        <ImageSection src={icons.twitter} />
      </SocialIcons>
      <SocialIcons>
        <ImageSection src={icons.facebook} />
      </SocialIcons>
      <SocialIcons>
        <ImageSection src={icons.linkedIn} />
      </SocialIcons>
    </Icons>
  )
}
export default ShareIcons
